var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{staticClass:"breadcrumb"},[_vm._l((_vm.breadcrumbList),function(it,id){return [_c('a-breadcrumb-item',{key:id},[_vm._v(" "+_vm._s(it.meta.title)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }